import type { GraphemeLessonPart } from "@-/dev.improve.haniverse.lib.level";
import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useLearnDeckNavigatorOptions } from "@-/dev.improve.haniverse.routes.nav.app.learn.deck.navigator";
import { useCallback } from "react";

/**
 * Opens the Learn deck on a new-character lesson's front. `face: "back"` lands on its mnemonics
 * directly (fast-forward); either way nothing is enrolled until the learner accepts the card.
 */
function useNavigator() {
  const getLearnDeckNavigatorOptions = useLearnDeckNavigatorOptions();

  return useCallback(
    ({
      face = "front",
      morpheme,
      part,
      pinyin,
    }: {
      face?: "back" | "front";
      morpheme: string;
      /** A pronunciation-level lesson (Level `2-P1`) of an already studied character. */
      part?: GraphemeLessonPart;
      /** Single-reading 2-P1 slot (干 gan4, then 干 gan1). */
      pinyin?: string;
    }) =>
      getLearnDeckNavigatorOptions({
        face,
        grapheme: morpheme,
        kind: "lesson",
        ...(part === undefined ? {} : { part }),
        ...(pinyin === undefined ? {} : { pinyin }),
        view: "study",
      }),
    [getLearnDeckNavigatorOptions],
  );
}

export const useNewMorphemeLessonPageNavigator = createPageNavigator({
  useNavigator,
});
